<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="schoolName">
                <span slot="label" ><a-tooltip>{{$t('学校名称')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.schoolName" :maxLength="32" :placeholder="$t('请输入')+'学校名称'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="schoolCode">
                <span slot="label" ><a-tooltip>{{$t('学校口令')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.schoolCode" :maxLength="32" :placeholder="$t('请输入')+$t('学校口令')" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('学校所在省')" prop="schoolAreap">
                <a-select :placeholder="$t('请选择')+$t('省份名称')" style="width: 100%" v-model="queryParam.schoolAreap" @change="schoolAreapChange" allowClear>
                  <a-select-option v-for="(item, index) in this.areaList" :value="item.areaId+''" :key="index">
                    {{ item.areaName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('学校所在市')" prop="schoolAreac">
                <a-select :placeholder="$t('请选择')+$t('城市')" style="width: 100%" v-model="queryParam.schoolAreac" allowClear>
                  <a-select-option v-for="(item, index) in this.cityList" :value="item.areaId+''" :key="index">
                    {{ item.areaName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="schoolAddress">
                <span slot="label" ><a-tooltip>{{$t('详细地区')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.schoolAddress" :maxLength="32" :placeholder="$t('请输入')+'详细地区'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('负责人')" prop="leaderId">
                <a-select  show-search :filter-option="leaderFilter"  v-model="queryParam.leaderId" :maxLength="32" :placeholder="$t('请选择')+$t('负责人')" allow-clear>
                  <a-select-option v-for="item in leaderList" :key="item.id">{{ item.leaderName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                     :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['school:school:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['school:school:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['school:school:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['school:school:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form :area-list = "areaList" ref="createForm" :leader-list="leaderList" @ok="getList"/>
      <batch-create-form ref="batchCreateForm" @ok="getList"/>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="schoolLogo" slot-scope="text, record">
          <div>
            <img v-if="record.schoolLogo" :src="record.schoolLogo" style="width:50px;height:50px;" @click="handleRecordPreview(record.schoolLogo)" alt="none"/>
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['school:school:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['school:school:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['school:school:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['school:school:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
          <br/>
          <a-divider type="vertical" />
          <a @click="handleJumpGrade(record.id)">
            <a-icon type="ordered-list" />{{$t('班级')}}
          </a>
          <a-divider type="vertical" v-if="record.isHaveBatch" />
          <a @click="handleJumpBatch(record.id)" v-if="record.isHaveBatch" >
            <a-icon type="ordered-list" />{{$t('查看批次')}}
          </a>
          <a-divider type="vertical" v-if="!record.isHaveBatch"/>
          <a @click="handleBatchDetail(record)" v-if="!record.isHaveBatch">
            <a-icon type="plus" />{{$t('新增批次')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSchool,listSchool, delSchool } from '@/api/school/school'
import {getSchoolBatch } from '@/api/school/schoolBatch'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import BatchCreateForm from '../schoolBatch/modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {areaListTree} from "@/api/logistics";
import {listSchoolLeader} from "@/api/school/schoolLeader";

export default {
  name: 'School',
  components: {
    CustomDictTag,
    BatchCreateForm,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      areaList: [],
      cityList: [],
      leaderList: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        schoolName: undefined,
        schoolCode: undefined,
        schoolLogo: undefined,
        schoolAddress: undefined,
        schoolAreap: undefined,
        schoolAreac: undefined,
        leaderId: undefined,
        schoolStatus: undefined,
        schoolDescription: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('学校名称'),
          dataIndex: 'schoolName',
          align: 'center'
        },
        {
          title: this.$t('学校logo'),
          dataIndex: 'schoolLogo',
          scopedSlots: { customRender: 'schoolLogo' },
          align: 'center'
        },
        {
          title: this.$t('学校所在地'),
          dataIndex: 'schoolAreaxName',
          align: 'center'
        },
        {
          title: this.$t('详细地区'),
          dataIndex: 'schoolAddress',
          align: 'center'
        },
        {
          title: this.$t('负责人'),
          dataIndex: 'leaderName',
          align: 'center'
        },
        {
          title: this.$t('学校口令'),
          dataIndex: 'schoolCode',
          align: 'center'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getAreaTree()
    this.getLeaderList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询学校列表 */
    getList () {
      this.loading = true
     pageSchool(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getAreaTree() {
      areaListTree().then(response => {
        this.areaList = response.data
      })
    },
    getLeaderList() {
      listSchoolLeader({}).then(response => {
        this.leaderList = response.data
      })
    },
    leaderFilter(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    schoolAreapChange(areaId) {
      this.queryParam.schoolAreac = undefined
      if (!areaId) {
        this.cityList = []
        return
      }
      const province = this.areaList.find(p => (p.areaId + '') === (areaId + '') || p.areaId === areaId)
      this.cityList = (province && province.children) ? province.children : []
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        schoolName: undefined,
        schoolCode: undefined,

        schoolLogo: undefined,
        schoolAddress: undefined,
        schoolAreap: undefined,
        schoolAreac: undefined,
        leaderId: undefined,
        schoolStatus: undefined,
        schoolDescription: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleJumpGrade(id) {
      this.$router.push({
        path: 'school/grade',
        query: {schoolId: id}
      })
    },
    handleJumpBatch(id) {
      this.$router.push({
        path: 'school/batch',
        query: {schoolId: id}
      })
    },
    handleBatchDetail(record) {
      if (record.isHaveBatch) {
        this.$refs.batchCreateForm.handleUpdate(record.id)
      } else {
        this.$refs.batchCreateForm.handleAdd(record.id)
      }
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let reqData = {"idList":this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delSchool(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/school/export',
            that.queryParam
          , `学校_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
